import { useScrollReveal } from "@/hooks/useScrollReveal";

const points = [
  {
    icon: "ri-calendar-check-line",
    title: "今日の時間割を即表示",
    desc: "コマンド一つで今日の授業スケジュールをDiscordに表示。朝のホームルームでも使えます。",
  },
  {
    icon: "ri-search-line",
    title: "曜日・時限を指定して確認",
    desc: "「月曜の3時限目は何？」もスラッシュコマンドで即答。いつでもどこでも確認できます。",
  },
  {
    icon: "ri-discord-line",
    title: "Discordにそのまま表示",
    desc: "アプリを切り替える必要なし。Discordのチャンネルで時間割がそのまま見られます。",
  },
];

export default function OverviewSection() {
  const { ref: headRef, visible: headVisible } = useScrollReveal();
  const { ref: cardsRef, visible: cardsVisible } = useScrollReveal();
  const { ref: mockRef, visible: mockVisible } = useScrollReveal();

  return (
    <section id="overview" className="py-32 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Top label + Headline */}
        <div
          ref={headRef}
          style={{
            opacity: headVisible ? 1 : 0,
            transform: headVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
          }}
        >
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-gray-400 mb-4">概要</p>
          <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-20">
            <h2 className="text-4xl md:text-5xl font-black text-black leading-tight max-w-lg">
              時間割の確認を、<br />もっとシンプルに。
            </h2>
            <p className="text-gray-500 text-base leading-relaxed max-w-sm">
              時間割くんはDiscordのスラッシュコマンドで動く軽量Botです。難しい設定は不要。追加してすぐ使えます。
            </p>
          </div>
        </div>

        {/* Feature points */}
        <div
          ref={cardsRef}
          className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-100 rounded-2xl overflow-hidden"
        >
          {points.map((p, i) => (
            <div
              key={p.title}
              className="bg-white p-10 flex flex-col gap-5"
              style={{
                opacity: cardsVisible ? 1 : 0,
                transform: cardsVisible ? "translateY(0)" : "translateY(20px)",
                transition: `opacity 0.7s ease-out ${i * 0.15}s, transform 0.7s ease-out ${i * 0.15}s`,
              }}
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-black">
                <i className={`${p.icon} text-white text-lg`}></i>
              </div>
              <div>
                <h3 className="text-black font-bold text-base mb-2">{p.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Visual mockup */}
        <div
          ref={mockRef}
          className="mt-20 rounded-3xl overflow-hidden bg-gray-50 border border-gray-100"
          style={{
            opacity: mockVisible ? 1 : 0,
            transform: mockVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.9s ease-out, transform 0.9s ease-out",
          }}
        >
          <div className="flex items-center gap-2 px-5 py-3.5 border-b border-gray-100 bg-white">
            <span className="w-3 h-3 rounded-full bg-gray-200"></span>
            <span className="w-3 h-3 rounded-full bg-gray-200"></span>
            <span className="w-3 h-3 rounded-full bg-gray-200"></span>
            <span className="ml-3 text-xs text-gray-400 font-mono"># 時間割チャンネル</span>
          </div>
          <div className="p-8 md:p-12">
            <img
              src="https://readdy.ai/api/search-image?query=Discord%20chat%20interface%20dark%20theme%20showing%20a%20timetable%20schedule%20bot%20response%20with%20clean%20table%20layout%20class%20schedule%20Monday%20to%20Friday%20minimal%20UI&width=1200&height=500&seq=mock1&orientation=landscape"
              alt="時間割くん 使用イメージ"
              className="w-full rounded-xl object-cover h-64 md:h-80"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
